import React from 'react';

import { ActionIcon, Button, Group, Stack } from '@mantine/core';
import { IconPlayerPlay, IconRefresh, IconPlayerPause } from '@tabler/icons-react';
import { useStopwatchTimer } from 'components/Workout/WorkoutTimer/Stopwatch/useStopwatchTimer';

import DisplayTime from '../DisplayTime';
import { formatMilisecondsToMMSS } from '../format';

function Stopwatch(): JSX.Element {
  const { elapsed, isRunning, start, reset, pause } = useStopwatchTimer();
  console.log('elapsed', elapsed);
  console.log('elapsed format', formatMilisecondsToMMSS(elapsed));

  return (
    <Stack spacing='md'>
      <DisplayTime value={formatMilisecondsToMMSS(elapsed)} />

      <Group align='end' noWrap sx={{ width: '100%' }}>
        {isRunning && (
          <Button leftIcon={<IconPlayerPause size={18} />} onClick={pause} sx={{ flex: 1, minWidth: 0 }}>
            Pause
          </Button>
        )}

        {!isRunning && (
          <Button leftIcon={<IconPlayerPlay size={18} />} onClick={start} sx={{ flex: 1, minWidth: 0 }}>
            Start
          </Button>
        )}

        <ActionIcon
          size={36}
          variant='outline'
          color='gray'
          onClick={reset}
          aria-label='Reset timer'
          sx={{ flex: '0 0 auto' }}
        >
          <IconRefresh size={20} />
        </ActionIcon>
      </Group>
    </Stack>
  );
}

export default Stopwatch;
